import type { UserId } from "@common/types/user";
import type { Flavor } from "@common/utils/type-utils";

export type Space = {
  id: SpaceId;
  name: string;
  icon: SpaceIcon;
  createdBy: UserId;
  createdDate: number;
};

export type SpaceId = Flavor<string, "SPACE_ID">;

export const SPACE_ICONS = [
  "home",
  "bookmark",
  "heart",
  "star",
  "code",
  "alarm",
  "plane",
  "music",
  "barbell",
  "circle",
  "book",
  "wrench",
  "people",
  "cloud",
  "sun",
  "compass",
  "map",
  "flag",
  "lightning",
  "lightbulb",
  "megaphone",
  "thumbsup",
  "palette",
  "moon",
] as const;

export type SpaceIcon = (typeof SPACE_ICONS)[number];

export function isValidSpaceIcon(icon: string): icon is SpaceIcon {
  return SPACE_ICONS.includes(icon as SpaceIcon);
}

/**
 * In order to make the assumption that spaceId is non-nullable
 * across the app, we need a default value before user spaces
 * have been loaded.
 */
export const CLIENT_DEFAULT_SPACE_ID = "anonymous_home";

export function isValidSpaceName(name: string) {
  // must be url safe
  return name.length && /^[a-zA-Z0-9_\s-]+$/.test(name);
}
